module.exports = __webpack_public_path__ + "img/paizhao.04759792.png";